import { FC, InputHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import RefreshArrow from '../icons/RefreshArrow'
type Input = InputHTMLAttributes<HTMLInputElement>
type IProps = {
  captchCode: number | string
  captchValue: number | string
  isCodeValid: boolean
  setCaptchaCode: () => void
  setCaptchaValue: (e: any) => void
}

const Recaptch: FC<IProps & Input> = ({
  captchCode,
  captchValue,
  setCaptchaCode,
  setCaptchaValue,
  isCodeValid,
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <div className=''>
      <div className='w-full flex items-center justify-between -mt-3 ml-4'>
        <div className='w-2/3 flex flex-col'>
          <label className='text-xs mr-3 mb-2.5'>{t('captchaCode')}</label>
          <input
            value={captchValue}
            onChange={setCaptchaValue}
            className={clsx(
              'text-gray-500 border-2 rounded-lg text-sm px-2.5 py-2 placeholder:text-gray-300 text-center',
              isCodeValid ? 'focus-shadow  border-gray-200' : 'focus-shadow--invalid invalid',
            )}
            {...props}
          />
        </div>
        <div className='flex items-center justify-between mt-7'>
          <p className='ml-3 text-sm text-gray-400'>{captchCode}</p>
          <div
            className='cursor-pointer text-gray-400 hover:text-blue-400 ease-in-out duration-200'
            onClick={setCaptchaCode}
          >
            <RefreshArrow />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Recaptch
